module.exports = __webpack_public_path__ + "img/correlacion-palabras.02e5b49d.png";